import { _ } from "../../../core/polyglot/polyglot.js";
import AccountingDocumentWidget from "../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import AccountsPayableAndReceivableStep from "../../../core/newWizard/ForecastWizard/steps/AccountsPayableAndReceivableStep.js";
import BankAccountStep from "../../../core/newWizard/ForecastWizard/steps/BankAccountStep.js";
import ForecastPayablesAndReceivablesStep from "../../../core/newWizard/ForecastWizard/steps/ForecastPayablesAndReceivablesStep.js";
import ForecastVatStep from "../../../core/newWizard/ForecastWizard/steps/ForecastVatStep.js";
import NumberOfPeriodsStep from "../../../core/newWizard/ForecastWizard/steps/NumberOfPeriodsStep.js";
import OldSpinnerWidget from "../../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import VatFlowStep from "../../../core/newWizard/ForecastWizard/steps/VatFlowStep.js";
import VatStep from "../../../core/newWizard/ForecastWizard/steps/VatStep.js";
import Wizard from "../../../core/newWizard/Wizard.js";
import WizardWithRoadmap from "../../../core/newWizard/WizardWithRoadmap/WizardWithRoadmap.js";

export const steps = [
	new BankAccountStep(),
	new VatFlowStep(),
	new ForecastVatStep(),
	new VatStep(),
	new ForecastPayablesAndReceivablesStep(),
	new AccountsPayableAndReceivableStep(),
	new NumberOfPeriodsStep(),
];

/**
 * Content of the Forecast on-boarding document. It solely consists of a Wizard.
 */
export default class ForecastOnBoardingDocumentContent extends AccountingDocumentWidget {
	setup({ onSuccess, onAbort }) {
		super.setup(...arguments);

		this._wizard = new Wizard({ onSuccess });

		this._wizard.addSteps(steps);

		this._wizardWidget = new WizardWithRoadmap({
			// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
			loader: new OldSpinnerWidget({ dark: true, size: 64 }),
			wizard: this._wizard,
			title: _("Set your company's default forecasting rules"),
			description: (html) => {
				html.p(
					_(
						"Set the following rules to determine where cash, VAT, Accounts receivable and payable flows. These will be used on all forecasting templates unless you adjust them.",
					),
				);

				html.p(
					_(
						"At the moment, we do not support extended fiscal year in forecast",
					),
				);
			},
		});

		this._wizard.aborted.register(onAbort);

		// We don't await here on purpose, to have an early rendering
		this._documentState.makeWizardContext().then((context) => {
			this._addGetAccountDropdownItemsToContext({ context });
			this._wizard.start({ context });
		});
	}

	renderContentOn(html) {
		html.render(this._wizardWidget);
	}

	_addGetAccountDropdownItemsToContext({ context }) {
		context.getAccountDropdownItems = ({ selectedFn = () => false } = {}) =>
			context.accounts.map((account) => ({
				name: account.toString(),
				id: account.getNumber(),
				match: (searchString) => account.match(searchString),
				selected: selectedFn(account),
			}));
	}
}
